import type { TFunction } from 'i18next';

import { getApiKey } from '../../../lib/flotiq-client';
import { parseResponseErrors } from '../../../lib/flotiq-client/response-errors';

export const getGlobalApiKeys = async (
  jwt: string,
  t: TFunction<'translation', undefined>,
) => {
  const { body, status, ok } = await getApiKey(jwt);

  if (!ok) {
    throw parseResponseErrors(body, status);
  }

  const rwApiKey = (body.data || []).find(
    ({ global, canRead, canCreate }) => global && canRead && canCreate,
  );
  const roApiKey = (body.data || []).find(
    ({ global, canRead, canCreate }) => global && canRead && !canCreate,
  );

  if (!rwApiKey)
    throw new Error(t('PopulateSpaceModal.Error.FetchApiKeyFailed'));

  return { rwApiKey: rwApiKey.apiKey, roApiKey: roApiKey?.apiKey };
};

export default getGlobalApiKeys;
